import type { Mark as MarkT } from '@xox/shared'
import { motion } from 'motion/react'

export function Mark({ mark, className = '' }: { mark: MarkT; className?: string }) {
  const stroke = mark === 'X' ? 'stroke-x' : 'stroke-o'
  return (
    <svg viewBox="0 0 100 100" className={`size-full ${stroke} ${className}`} aria-hidden>
      {mark === 'X' ? (
        <>
          <motion.path
            d="M22 22 L78 78"
            fill="none"
            strokeWidth="12"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.18, ease: 'easeOut' }}
          />
          <motion.path
            d="M78 22 L22 78"
            fill="none"
            strokeWidth="12"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.18, ease: 'easeOut', delay: 0.1 }}
          />
        </>
      ) : (
        <motion.circle
          cx="50"
          cy="50"
          r="28"
          fill="none"
          strokeWidth="12"
          initial={{ pathLength: 0, rotate: -90 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.28, ease: 'easeOut' }}
        />
      )}
    </svg>
  )
}
